/**
 * Copyright 2017-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {HOMING_HOME_ICON, HOMING_MAXIMIZE_ICON, toggleHoming} from '../actions/display';
import LocaleUtils from '../utils/LocaleUtils';
import {zoomToExtent, panTo} from '../actions/map';
import Icon from '../components/Icon';
import './style/Buttons.css';


/**
 * Map button for reverting to the home extent of the theme.
 */
class HomeButton extends React.Component {
    static propTypes = {
        currentTheme: PropTypes.object,
        icon: PropTypes.string,
        homeState: PropTypes.bool = true,
        /** The position slot index of the map button, from the bottom (0: bottom slot). */
        position: PropTypes.number,
        splitScreen: PropTypes.object,
        toggleHoming: PropTypes.func,
        zoomToExtent: PropTypes.func,
        panTo: PropTypes.func
    };
    static defaultProps = {
        position: 5
    };
    render() {
        const splitWindows = Object.values(this.props.splitScreen);
        const right = splitWindows.filter(entry => entry.side === 'right').reduce((res, e) => Math.max(e.size, res), 0);
        const bottom = splitWindows.filter(entry => entry.side === 'bottom').reduce((res, e) => Math.max(e.size, res), 0);
        const style = {
            right: 'calc(1.5em + ' + right + 'px)',
            bottom: 'calc(' + bottom + 'px + ' + (5 + 4 * this.props.position) + 'em)'
        };
        const tooltipMsg = {
            home: LocaleUtils.tr("tooltip.home"),
            maximize: LocaleUtils.tr("tooltip.homeToMap"),
        };
        //const tooltip = this.props.homeState ? LocaleUtils.tr("tooltip.home") : LocaleUtils.tr("tooltip.homeToMap");
        //const tooltipIcon = this.props.homeState ? "home" : "maximize";
        return (
            <button className="map-button" onClick={this.onClick} style={style} title={tooltipMsg[this.props.icon]}>
                <Icon icon={this.props.icon} title={tooltipMsg[this.props.icon]}/>
            </button>
        );
    }
    onClick = () => {
        //console.log("onClick with homeState: " + this.props.homeState)
        if (this.props.homeState) {
            this.panToHome();
        } else {
            this.resetExtent();
        }
        this.props.homeState = !this.props.homeState;
        this.props.toggleHoming(this.props.homeState);
    };
    resetExtent = () => {
        if (this.props.currentTheme) {
            const bbox = this.props.currentTheme.initialBbox;
            this.props.zoomToExtent(bbox.bounds, bbox.crs);
        }
    };

    panToHome = () => {
        //console.log("Panning to home called");
        if (this.props.currentTheme) {
            if (navigator.geolocation) {
                const bbox = this.props.currentTheme.initialBbox;
                navigator.geolocation.getCurrentPosition((position) => {
                    //console.log("Panning to home", position.coords);
                    this.props.panTo([position.coords.longitude, position.coords.latitude], bbox.crs);
                }, (err) => {
                    console.log("Geolocation Permission Denied");
                });
            } else {
                console.log("No geolocation");
            }
        } else {
            console.log("No current theme to pan-to-home");
        }
    };
}

export default connect((state) => ({
    homeState: state.display.homeState,
    icon: state.display.icon,
    currentTheme: state.theme.current,
    splitScreen: state.windows.splitScreen
}), {
    toggleHoming: toggleHoming,
    zoomToExtent: zoomToExtent,
    panTo: panTo
})(HomeButton);
